import { useSelector } from "react-redux";
import {
  findSubModuleByName,
  isProvisioningLoaded,
} from "services/utils/HelperFunction";
import { permissionsFromFlags } from "services/utils/screenPermissions";

// Check-In Policy and Geo Fenced Sites are provisioned under Team
// Workspace's own "Settings" module (they used to be read from People's
// "Settings" module, before the backend moved them).
export const SETTINGS_MODULE = "Settings";
export const TEAM_WORKSPACE_PRODUCT = "Team Workspace";

// Same rule as every other screen (services/utils/screenPermissions.js):
// editor adds and updates, approver deletes and approves, either one or
// viewer opens the screen. A missing submodule grants nothing.
export const resolveSettingsAccess = (moduleDetails, subModuleName) =>
  permissionsFromFlags(
    findSubModuleByName(moduleDetails, SETTINGS_MODULE, subModuleName)
      ?.permissions,
  );

export const useTeamSettingsAccess = (subModuleName) => {
  const userScreenAccess = useSelector(
    (state) => state.tokenReducer.userScreenAccess,
  );

  // Redux holds one product's payload at a time; wait for Team Workspace's.
  const loaded = isProvisioningLoaded(userScreenAccess, TEAM_WORKSPACE_PRODUCT);
  const moduleDetails = loaded ? userScreenAccess?.module_details : null;

  return {
    loading: !loaded,
    moduleDetails: moduleDetails || [],
    ...resolveSettingsAccess(moduleDetails, subModuleName),
  };
};
